import { profileConstants } from '../constants/profileConstants';

const initialState = {
    sessionId : 'anonymous',
    webPushId : null,
    pushSubscriptionEndpoint: null,
    language: null,
    id : null,
    dateEnd: null,
    dateStart: null,
    Client: {}, 
    Room: {},
    initied : false,
    doNotDisturb: false,
    doNotClean: false,
    pricePerDay: 0,
    consumptions : [],
    notifications: []
};

const profileReducer = (state = initialState, action) => {
    switch (action.type) {
        case profileConstants.SESSION_ID : 
            return {
                ...state, sessionId : action.sessionId
            }
        case profileConstants.WEBPUSH_SUSCRIBE_SUCCESS :
            return {
                ...state, webPushId : action.webPushId, pushSubscriptionEndpoint: action.pushSubscriptionEndpoint
            }
        case profileConstants.CHANGE_LANGUAGE : 
            return {
                ...state, language : action.language
            }
        case profileConstants.INIT :
            return {
                ...state, ...action.data
            }
        case profileConstants.INITIED :
            return {
                ...state, initied : true
            }
        case profileConstants.DO_NOT_DISTURB :
            return {
                ...state, doNotDisturb : action.state
            }
        case profileConstants.CONSUMPTIONS_SUCCESS :
            return {
                ...state, consumptions : action.items
            }
        case profileConstants.NOTIFICATIONS_SUCCESS :
            return {
                ...state, notifications : action.items
            }
        case profileConstants.ROOM_OCCUPATION_UPDATED : 
            const _newState = { ...state }
            if (action.data?.doNotDisturb !== undefined) {
                _newState.doNotDisturb = action.data.doNotDisturb;
            }
            if (action.data?.dateEnd !== undefined) {
                _newState.dateEnd = action.data.dateEnd;
            }
            if (action.data?.Room !== undefined) {
                _newState.Room = action.data.Room;
            }
            return _newState
        case profileConstants.RESET :
            return {
                ...initialState
            }
        default:
            return state
    }
}

export default profileReducer